import TopBar from './TopBar'
import RandomPingCirlces from './RandomPingCirlces'

const Hero = () => {
  return (
    <div>
      <TopBar/>
      <div className="relative min-h-screen flex items-center justify-center
      bg-gradient-to-b from-black via-[#0d0d0d] to-[#111111] text-white px-6 text-center">
        <div className='inset-0 z-10 pointer-events-none'>
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
            <RandomPingCirlces/>
          </div>
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-32 h-[100vh] overflow-hidden pointer-events-none">
            <RandomPingCirlces/>
          </div>
        </div>
        <div className="relative z-20">
          <h1 className="text-5xl md:text-7xl font-black mb-4 bg-gradient-to-r from-pink-500 via-violet-400 to-cyan-400 bg-clip-text text-transparent">
            wamoody.com
          </h1>
          <p className="text-gray-400 text-lg md:text-xl mb-6 font-light tracking-wide">
            Software Engineer &amp; CS Student
          </p>
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {['React', 'Node.js', 'Go', 'Python', 'AWS', 'MongoDB'].map(tech => (
              <span key={tech} className="px-3 py-1 text-xs font-semibold rounded-full border border-gray-600 bg-[#1a1a1a] text-gray-300">
                {tech}
              </span>
            ))}
          </div>
          <a href="#projects">
            <button className="bg-gradient-to-r from-pink-500 to-violet-500 text-white
            font-bold px-8 py-3 rounded-full shadow-[0_0_24px_rgba(255,45,120,0.4)]
            hover:shadow-[0_0_36px_rgba(255,45,120,0.6)] hover:scale-105 transition-all duration-200">
              Jump To Projects
            </button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Hero
